import { enter } from 'el-transition'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'pendingOverlay',
    'successfulOverlay',
  ]

  connect() {
    if (this.hasPendingOverlayTarget) {
      enter(this.pendingOverlayTarget)
    }

    if (this.hasSuccessfulOverlayTarget) {
      enter(this.successfulOverlayTarget)
    }
  }
}
